// extracted by mini-css-extract-plugin
var _1 = "src-components-SignupForm-_TextDialog__dialogCloseButton--FCa912DqyooQQy9JPBHN";
var _2 = "src-components-SignupForm-_TextDialog__dialogCloseButtonWrapper--kfSzxzN7VMCr4HiPzKQQ";
var _3 = "src-components-SignupForm-_TextDialog__dialogText--XTSVBzRMkvQQaJYmw2qv";
var _4 = "src-components-SignupForm-_TextDialog__textDialog--Vl6sh5zSMkayqM5y3Bvt";
export { _1 as "dialogCloseButton", _2 as "dialogCloseButtonWrapper", _3 as "dialogText", _4 as "textDialog" }
